export default __webpack_public_path__ + "static/media/Gallery.339008dd.png";